import {
  type IMessageFilteredListProps,
  MessageFilteredList,
} from '../../messages/MessageFilteredList.tsx';
import { AlignRow, type AlignRowProps } from '../../row/AlignRow.tsx';

export interface IAdminMessageFilteredListProps
  extends IMessageFilteredListProps {
  align?: AlignRowProps['justify'];
}

export function AdminMessageFilteredList(
  props: IAdminMessageFilteredListProps,
) {
  return (
    <AlignRow justify={props.align ?? 'center'}>
      <MessageFilteredList {...props} />
    </AlignRow>
  );
}
